export default "__VITE_ASSET__BDXi1$9v__"